import { type FormEvent, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { Field, Input } from '../components/form';
import { Alert, Button, Card } from '../components/ui';
import { ThemeSwitcher } from '../theme/ThemeSwitcher';
import styles from './screens.module.css';

export function Login({ onForgot }: { onForgot?: () => void }) {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    if (!email.trim() || !senha) {
      setErro('Informe e-mail e senha.');
      return;
    }
    setEnviando(true);
    const status = await signIn(email.trim(), senha);
    setEnviando(false);
    if (status === 429) setErro('Muitas tentativas. Tente novamente em alguns minutos.');
    else if (status !== 200) setErro('E-mail ou senha inválidos.');
  }

  return (
    <div className={styles.centerScreen}>
      <Card className={styles.authCard}>
        <div className={styles.authHead}>
          <span className={styles.brand}>eCondomínio</span>
          <ThemeSwitcher compact />
        </div>
        <h1>Entrar</h1>
        <p className="muted">Acesse com seu e-mail e senha.</p>
        <form onSubmit={onSubmit} noValidate>
          <Field label="E-mail">
            {(id) => (
              <Input
                id={id}
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            )}
          </Field>
          <Field label="Senha">
            {(id) => (
              <Input
                id={id}
                type="password"
                autoComplete="current-password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
            )}
          </Field>
          {erro ? <Alert kind="danger">{erro}</Alert> : null}
          <div style={{ marginTop: 'var(--space-4)' }}>
            <Button type="submit" block disabled={enviando}>
              {enviando ? 'Entrando…' : 'Entrar'}
            </Button>
          </div>
          {onForgot ? (
            <div style={{ marginTop: 'var(--space-3)' }}>
              <Button block variant="ghost" onClick={onForgot}>
                Esqueci minha senha
              </Button>
            </div>
          ) : null}
          <div style={{ marginTop: 'var(--space-3)' }}>
            <Button block variant="ghost" onClick={() => window.location.assign('/cadastro')}>
              Cadastrar meu condomínio
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
